import { Version } from '@angular/core';

/** Current version of Angular Flex-Layout. */
export const VERSION = new Version('21.0.0');
